import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "page-content-inner" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "page-content-inner" }
const _hoisted_5 = { class: "button-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GroupPageBuilder = _resolveComponent("GroupPageBuilder")!
  const _component_SidebarLayout = _resolveComponent("SidebarLayout")!
  const _component_VButton = _resolveComponent("VButton")!

  return (_ctx.user)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_SidebarLayout, { theme: "labels-hover" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_GroupPageBuilder)
            ])
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createVNode(_component_SidebarLayout, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_VButton, {
                  color: "primary",
                  elevated: "",
                  rounded: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('login')))
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode(" Please login ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]))
}